import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Atividade',
  empty: 'As leituras do feed e os envios de fotos aparecem aqui.',
  feed: {
    title: 'Feed lido',
    subjects: {
      one: '{{value}} atleta',
      other: '{{value}} atletas',
    },
    revoked: {
      one: '{{value}} revogado',
      other: '{{value}} revogados',
    },
  },
  received: {
    title: {
      one: '{{value}} foto nova',
      other: '{{value}} fotos novas',
    },
    requests: {
      one: 'em {{value}} envio',
      other: 'em {{value}} envios',
    },
  },
  rejected: {
    title: {
      one: '{{value}} foto recusada',
      other: '{{value}} fotos recusadas',
    },
    reason: 'atleta revogado ou desconhecido',
  },
  keyCreated: 'Chave gerada pela equipe Bodyprint',
  keyRevoked: 'Chave revogada pela equipe Bodyprint',
} satisfies TranslationTree;
